<template>
  <b-container class="pt-2 pb-2">
    <PoisForm class="align-content-center" />
  </b-container>
</template>

<script>
import PoisForm from '@/components/PoisForm';

export default {
  name: 'PoisAdd',
  components: { PoisForm },
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped></style>
